import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/models/notification.message';
import { ChangePasswordVm } from 'src/app/models/requests/ChangePasswordVm';
import { CustomvalidationService } from 'src/app/services/customvalidation.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-changepwd',
  templateUrl: './changepwd.component.html',
  styleUrls: ['./changepwd.component.css']
})
export class ChangepwdComponent implements OnInit {
  currPassVisible:boolean = true;
  currentType:boolean = true; 
  visiblePassword:boolean = true;
  changetype:boolean = true;
  visibleConfirmPassword: boolean = true;
  changeConfirmType: boolean = true;
  changepwdForm!: FormGroup;
  oldpassword:string= '';
  password:string ='';
  confirmPassword:string= '';

  submitted = false;
  constructor( private userService: UserService, private router: Router,  private notification: NotificationService,private fb: FormBuilder,
    private customValidator: CustomvalidationService) { }

    ngOnInit() {
      
    }
    viewcurrentpassword(){
      this.currPassVisible = !this.currPassVisible;
      this.currentType = !this.currentType;
    }

    viewpassword(){
      this.visiblePassword = !this.visiblePassword;
      this.changetype = !this.changetype;
    }

    viewconfirmpassword(){
      this.visibleConfirmPassword = !this.visibleConfirmPassword;
      this.changeConfirmType = !this.changeConfirmType;
    }
  

  onSubmit() {
    if (this.confirmPassword != this.password)
    {
      
      this.notification.sendMessage({
        message: 'New Password and confirm password do not match',
        type: NotificationType.error
      });

      return;

    }
    this.changePassword();
    
  }
  changePassword(){
    const changepwdModel: ChangePasswordVm = {} as ChangePasswordVm;
    changepwdModel.newPassword = this.password;
    changepwdModel.currentPassword = this.oldpassword;

    this.userService.chanegPassword(changepwdModel).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          window.localStorage.clear();
          this.router.navigate(['signin']);

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
            

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });






  }
}
